import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import './vendorPortal.scss';
import VendorLayout from './VendorLayout';
import VendorLogin from './pages/VendorLogin';
import VendorDashboard from './pages/VendorDashboard';
import VendorRequisitions from './pages/VendorRequisitions';
import VendorQuoteForm from './pages/VendorQuoteForm';
import VendorMyQuotations from './pages/VendorMyQuotations';
import VendorQuotationDetail from './pages/VendorQuotationDetail';
import VendorChallans from './pages/VendorChallans';
import VendorProfile from './pages/VendorProfile';
import { isVendorLoggedIn } from './api/vendorApi';

// Auth guard: send unauthenticated visitors to the vendor login (never the
// staff login). This is completely independent of the staff auth context.
const RequireVendorAuth = ({ children }: { children: React.ReactNode }) => {
	if (!isVendorLoggedIn()) {
		return <Navigate to='/vendor-portal/login' replace />;
	}
	return <>{children}</>;
};

const VendorPortalApp = () => {
	return (
		<Routes>
			<Route path='login' element={<VendorLogin />} />
			<Route
				element={
					<RequireVendorAuth>
						<VendorLayout />
					</RequireVendorAuth>
				}>
				<Route path='dashboard' element={<VendorDashboard />} />
				<Route path='requisitions' element={<VendorRequisitions />} />
				<Route path='requisitions/:id' element={<VendorQuoteForm />} />
				<Route path='quotations' element={<VendorMyQuotations />} />
				<Route path='quotations/:id' element={<VendorQuotationDetail />} />
				<Route path='challans' element={<VendorChallans />} />
				<Route path='profile' element={<VendorProfile />} />
			</Route>
			<Route path='' element={<Navigate to='dashboard' replace />} />
			<Route path='*' element={<Navigate to='dashboard' replace />} />
		</Routes>
	);
};

export default VendorPortalApp;
